module.exports = __webpack_public_path__ + "static/img/vip_privilege4.457f5c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege4.png
// module id = JubR
// module chunks = 0